import getTransitionEnd from '../../../scripts/utilities/get-transition-end';


(function header() {

	const headerEl = document.querySelector('.header-main');

	if (!(headerEl instanceof Element)) {
		console.warn('No header element found');
		return;
	}

	const searchForm = headerEl.querySelector('.header-main-search-form');
	const searchOpen = headerEl.querySelector('.header-main-search-open');
	const searchClose = headerEl.querySelector('.header-main-search-close');

	const navToggle = headerEl.querySelector('.header-main-control-toggle');
	const nav = headerEl.querySelector('.header-main-nav');

	searchOpen.addEventListener('click', onOpenFactory(searchForm), false);
	searchClose.addEventListener('click', onCloseFactory(searchForm), false);

	const onNavOpen = onOpenFactory(nav);
	const onNavClose = onCloseFactory(nav);
	let isNavOpen = false;


	navToggle.addEventListener('click', onNavToggle, false);

function onNavToggle() {

    if (isNavOpen) {
        onNavClose();
        isNavOpen = false;
    } else {
        onNavOpen();
        isNavOpen = true;
    }
}
}());

(function dropDownMenu() {

    const ddToggle = document.querySelector('.dropdown-menu-toggle');
    let isDDOpen, DDNav, onDDOpen, onDDClose;

    if (ddToggle) {
        DDNav = document.querySelector('.dropdown-menu-nav');

        onDDOpen = onOpenFactory(DDNav);
        onDDClose = onCloseFactory(DDNav);
        isDDOpen = false;

        ddToggle.addEventListener('click', onDDToggle, false);
    }
    

    function onDDToggle() {

        if (isDDOpen) {
            onDDClose();
            isDDOpen = false;
        } else {
            onDDOpen();
            isDDOpen = true;
        }
    }
}());

function onOpenFactory(el) {

    return function onOpen() {
        requestAnimationFrame(() => {
            el.classList.add('-is-display-block');

            requestAnimationFrame(() => {
                el.classList.add('-is-visible');
            });
        });
    };
}

function onCloseFactory(el) {

    return function onClose() {

        function onTransitionEnd() {
            el.classList.remove('-is-display-block');
            el.removeEventListener(getTransitionEnd(), onTransitionEnd);
        }

        el.addEventListener(getTransitionEnd(), onTransitionEnd, false);
        el.classList.remove('-is-visible');
    };
}

